import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Logo from "../../assets/images/Yogify.png";
import { GiPrayerBeads } from "react-icons/gi";
import { RiSecurePaymentLine } from "react-icons/ri";
import { FcGoogle } from "react-icons/fc";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import apiClient from "../../services/apiClient";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { setUser } from "../../features/auth/authSlice";
import LoginBanner from '../../assets/images/login.jpg'

const Signup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    whatsapp: "",
    password: "",
    confirmPassword: ""
  });

  const [errorData, setErrorData] = useState({
    name: "",
    email: "",
    mobile: "",
    whatsapp: "",
    password: "",
    confirmPassword: ""
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errorData[name]) {
      setErrorData(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errorData };
    const emailRegex = /^\S+@\S+\.\S+$/;
    const phoneRegex = /^\d{10}$/;

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Full name is required";
      isValid = false;
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
      isValid = false;
    }

    // Mobile validation
    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!phoneRegex.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
      isValid = false;
    }

    // WhatsApp validation (optional but must be valid if provided)
    if (formData.whatsapp && !phoneRegex.test(formData.whatsapp)) {
      newErrors.whatsapp = "Please enter a valid 10-digit WhatsApp number";
      isValid = false;
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
      isValid = false;
    }

    // Confirm Password validation
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
      isValid = false;
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrorData(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        secondary_phone: formData.mobile,
        phone: formData.whatsapp || formData.mobile, 
        password: formData.password,
        confirm_password: formData.confirmPassword
      };

      const res = await apiClient.post('/register', payload);
      
      if (res.status == 200 || res.status == 201) {
        console.log(res)
        dispatch(setUser(res.data));
        toast.success("Account created successfully!");
        navigate('/'); 
      } else {
        
        if (res.data.errors) {
          const serverErrors = {};
          Object.keys(res.data.errors).forEach(key => {
            serverErrors[key] = res.data.errors[key][0];
          });
          setErrorData(prev => ({ ...prev, ...serverErrors }));
        } else {
          toast.error(res.data.message || "Registration failed");
        }
      }
    } catch (error) {
      console.error("Registration error:", error);
      if (error.response?.data?.errors) {
        const serverErrors = {};
        Object.keys(error.response.data.errors).forEach(key => {
          serverErrors[key] = error.response.data.errors[key][0];
        });
        setErrorData(prev => ({ ...prev, ...serverErrors }));
      } else {
        toast.error(error.response?.data?.message || "Registration failed. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async (tokenResponse) => {
    try {
      setIsLoading(true);
      const accessToken = tokenResponse.access_token;

      // Fetch user info from Google API
      const userInfoRes = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const userInfo = await userInfoRes.json();

      const payload = {
        email: userInfo.email,
        name: userInfo.name,
        google_id: userInfo.sub,
      };

      const res = await apiClient.post("/login/google", payload);
      dispatch(setUser(res.data));
      toast.success("Google sign-in successful!");
      navigate('/'); // Redirect to home after login
    } catch (err) {
      console.error(err);
      toast.error("Google login failed");
    } finally {
      setIsLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: handleGoogleLogin,
    onError: () => toast.error("Google login failed"),
  });

    

  const handleCustomGoogleLogin = () => {
    login(); 
  };

  return (
    <div id="Signup">
      <div className="container">
        <div className="LoginMain">
          <div className="LoginBox">
            <div className="LoginLeftBox">
              {/* <div className="LoginLogo">
                <img src={Logo} alt="Yogify Logo" />
              </div>
              <div className="LoginTitle">
                <h2>
                  Authentic Spiritual Essentials to Help You Connect with Your
                  True Self
                </h2>
              </div>
              <div className="ProductSecureBox">
                <div className="SecureBox">
                  <div className="IconBox">
                    <GiPrayerBeads className="SecureIcon" />
                  </div>
                  <div className="SecureTitle">
                    <p>Soulful Accessories</p>
                  </div>
                  <div className="SecureDescription">
                    <p>Crafted with Trusted Spiritual Quality</p>
                  </div>
                </div>

                <div className="SecureBox">
                  <div className="IconBox">
                    <RiSecurePaymentLine className="SecureIcon" />
                  </div>
                  <div className="SecureTitle">
                    <p>Secure Checkout</p>
                  </div>
                  <div className="SecureDescription">
                    <p>Multiple Payment Options — Fast, Safe & Secure</p>
                  </div>
                </div>
              </div> */}
              <img src={LoginBanner} alt="" />
            </div>
            <div className="LoginRightBox">
              <div className="Title">
                <h2>Signup</h2>
                <p>
                  Create your account to explore our spiritual collection
                </p>
              </div>

              <div className="LoginFormGroup">
                <form onSubmit={handleSubmit} noValidate>
                  <div className="FormField">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      className={errorData.name ? 'error' : ''}
                    />
                    {errorData.name && <span className="error-message">{errorData.name}</span>}
                  </div>

                  <div className="FormField">
                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className={errorData.email ? 'error' : ''}
                    />
                    {errorData.email && <span className="error-message">{errorData.email}</span>}
                  </div>

                  <div className="FormField PhoneField">
                    <label>Mobile Number</label>
                    <div className="PhoneInputWrapper">
                      <span className="CountryCode">+91</span>
                      <input
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        placeholder="Enter mobile number"
                        maxLength="10"
                        className={errorData.mobile ? 'error' : ''}
                      />
                    </div>
                    {errorData.mobile && <span className="error-message">{errorData.mobile}</span>}
                  </div>

                  <div className="FormField PhoneField">
                    <label>WhatsApp Number (optional)</label>
                    <div className="PhoneInputWrapper">
                      <span className="CountryCode">+91</span>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleChange}
                        placeholder="Enter WhatsApp number"
                        maxLength="10"
                        className={errorData.whatsapp ? 'error' : ''}
                      />
                    </div>
                    {errorData.whatsapp && <span className="error-message">{errorData.whatsapp}</span>}
                  </div>

                  <div className="FormField PasswordField">
                    <label>Password</label>
                    <div className="PasswordInputWrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Create password (min 8 characters)"
                        className={errorData.password ? 'error' : ''}
                      />
                      <button
                        type="button"
                        className="TogglePassword"
                        onClick={togglePasswordVisibility}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                      </button>
                    </div>
                    {errorData.password && <span className="error-message">{errorData.password}</span>}
                  </div>

                  <div className="FormField PasswordField">
                    <label>Confirm Password</label>
                    <div className="PasswordInputWrapper">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        placeholder="Confirm password"
                        className={errorData.confirmPassword ? 'error' : ''}
                      />
                      <button
                        type="button"
                        className="TogglePassword"
                        onClick={toggleConfirmPasswordVisibility}
                        aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                      >
                        {showConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                      </button>
                    </div>
                    {errorData.confirmPassword && <span className="error-message">{errorData.confirmPassword}</span>}
                  </div>

                  <div className="LoginBtn">
                    <button type="submit" disabled={isLoading}>
                      {isLoading ? 'Creating Account...' : 'Create Account'}
                    </button>
                  </div>
                </form>
              </div>

              <div className="OrText">
                <p>Or continue with social account</p>
              </div>

              <div className="GoogleBtn">
                <button onClick={handleCustomGoogleLogin} disabled={isLoading}>
                  <FcGoogle />
                  <p>Sign up with Google</p>
                </button>
              </div>

              <div className="DontAccount">
                <p>Already have an account?</p>
                <a href="/auth/login">Login</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;